import { UserId } from '@cibo/core'
import { PaginatedFieldsContext, useAssignFields } from '@cibo/landmanager'
import { AssignUserField } from '@cibo/profile'
import { FriendlyError, ResponsiveDialog } from '@cibo/ui'
import BugReportRounded from '@mui/icons-material/BugReportRounded'
import WarningIcon from '@mui/icons-material/WarningAmberOutlined'
import { LoadingButton } from '@mui/lab'
import {
  Alert,
  AlertTitle,
  Button,
  ButtonProps,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from '@mui/material'
import { Form, Formik } from 'formik'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const BulkAssignOwnerButton = (props: ButtonProps) => {
  const { t } = useTranslation('impact/EnrollSelectedFields')
  const { selectedFields, selectedRowIds } = useContext(PaginatedFieldsContext)
  const [pickerOpen, setPickerOpen] = useState(false)
  const [userId, setUserId] = useState<UserId>()

  const assignFields = useAssignFields()

  const handleClickAssignOwner = () => {
    !!userId &&
      assignFields.mutateAsync({
        messageUser: false,
        userId,
        resourceIds: selectedRowIds as string[],
      })
  }
  useEffect(() => assignFields.reset(), [pickerOpen])

  const canAssignFields = selectedFields?.length

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <LoadingButton
          color="secondary"
          variant="outlined"
          {...props}
          onClick={() => setPickerOpen(true)}
          disabled={!canAssignFields}
          startIcon={<BugReportRounded color="error" />}
        >
          Assign To User
        </LoadingButton>
      </Stack>

      <ResponsiveDialog
        fullWidth
        maxWidth="sm"
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
      >
        <DialogTitle>Assign Fields To User</DialogTitle>

        <DialogContent>
          <Stack spacing={2}>
            <Alert
              severity="warning"
              icon={<WarningIcon color="warning" sx={{ mt: '15px', mx: '9px' }} />}
            >
              <AlertTitle>Let's double check...</AlertTitle>
              Are you sure you want to assign {selectedRowIds.length} field(s)?
            </Alert>

            <Formik initialValues={{ owner: 1 }} onSubmit={console.log}>
              {props => {
                setUserId(props.values.owner)
                return (
                  <Form>
                    <AssignUserField name="owner" required />
                  </Form>
                )
              }}
            </Formik>

            {!!assignFields.error && (
              <FriendlyError
                message={
                  // @ts-ignore assignFields error mistyped
                  assignFields.error.response?.data.message || JSON.stringify(assignFields.error)
                }
              />
            )}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setPickerOpen(false)}>{t('cancel')}</Button>
          <LoadingButton
            onClick={handleClickAssignOwner}
            loading={assignFields.isLoading}
            variant="contained"
            color="secondary"
            disabled={!userId}
          >
            Assign To User
          </LoadingButton>
        </DialogActions>
      </ResponsiveDialog>
    </>
  )
}
